// There are a few oddities with team names. Team names are prefixed with "Team"
// The United States can be "United States" or "USA"
// TODO: We should unify the team names on the backend
export const formatInternationalTeam = (teamName: string): string => {
    const name = teamName.replace('Team', '').trim();
    return name === 'USA' ? 'United States' : name;
};
